import React from "react";
import { FormControl, Select, MenuItem, Typography, Box, useTheme } from "@mui/material";
import { useLanguage } from "../../contexts/LanguageContext";
import { useTranslation } from "react-i18next";

// Flag emoji characters
const FLAGS = {
  en: '🇬🇧',
  fr: '🇫🇷',
  ar: '🇸🇦'
};

const languages = [
  {
    code: "en",
    name: "English",
    shortCode: "ENG",
    flag: FLAGS.en
  },
  {
    code: "fr",
    name: "French",
    shortCode: "FR",
    flag: FLAGS.fr
  },
  {
    code: "ar",
    name: "Arabic",
    shortCode: "AR",
    flag: FLAGS.ar
  },
];
const LanguageSwitcher = ({
  label,
  value,
  onChange,
  disabled = false,
  isAppbar = false,
}) => {
  const { t } = useTranslation();
  const { currentLanguage, changeLanguage } = useLanguage();
  const isRTL = currentLanguage === "ar";
  const theme = useTheme();

  const handleLanguageChange = async (event) => {
    const lang = event.target.value;
    try {
      await changeLanguage(lang);
      if (onChange) {
        onChange(lang);
      }
    } catch (error) {
      console.error("Failed to change language:", error);
    }
  };

  return (
    <Box sx={{ minWidth: isAppbar ? 80 : 120 }}>
      <FormControl fullWidth dir={isRTL ? "rtl" : "ltr"} size="small">
        {!isAppbar && (
          <Typography variant="caption" sx={{ mb: 0.5, ml: 0.5, color: theme.palette.text.secondary }}>
            {label || t("common.language")}
          </Typography>
        )}
        <Select
          id="language-select"
          value={value || currentLanguage}
          onChange={handleLanguageChange}
          disabled={disabled}
          sx={{
            color: isAppbar 
              ? (theme.palette.mode === "light" ? theme.palette.primary.main : "#ffffff")
              : undefined,
            border: theme.palette.mode === "light" ? `1px solid ${theme.palette.grey[300]}` : " #ffffff",
            borderRadius: '20px',
            "& .MuiSelect-icon": {
              color: isAppbar 
                ? (theme.palette.mode === "light" ? theme.palette.primary.main : "#ffffff")
                : undefined,
            },
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 0.5,
              textAlign: "center",
              padding: isAppbar ? '6px 10px' : undefined,
              fontSize: '0.85rem',
            },
          }}
        >
          {languages.map((lang) => (
            <MenuItem
              key={lang.code}
              value={lang.code}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                justifyContent: "center",
                width: "100%",
                textAlign: "center",
                fontSize: '0.85rem',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <span style={{ fontSize: '1.1rem' }}>{lang.flag}</span>
                <Typography variant="body2" sx={{ fontWeight: lang.code === (value || currentLanguage) ? 'bold' : 'normal' }}>
                  {lang.shortCode}
                </Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageSwitcher;
